import React from 'react';
import { useQuery } from '@apollo/client';
import Navbar from '../../../../components/Navbar';
import { queryPerDeptRefresh } from '../api';
import { perDeptColumns } from '../utils';
import ReactTable from 'react-table';
import { Loader } from '../../../../components/Loader';
import { Button } from 'react-bootstrap';

export const PerDeptDeviceList = (props: any) => {
  let vars = Object({
    deptId: parseInt(props.match.params.deptId),
  });
  if (props.match.params.sixYears === 'true') {
    vars = { ...vars, sixYears: true };
  }

  const { loading, error, data } = useQuery(queryPerDeptRefresh, {
    variables: vars,
  });

  if (loading) {
    return (
      <div>
        <Navbar />
        <Loader />
      </div>
    );
  }
  if (error) {
    return (
      <React.Fragment>
        <Navbar />
        <h2>Error with data...</h2>
      </React.Fragment>
    );
  }
  if (data) {
    return (
      <React.Fragment>
        <Navbar />
        <div className='container-fluid mt-1'>
          <div className='row justify-content-start'>
            <div className='col-sm-6'>
              <h2>{`Device Refresh Data for ${data.queryDeviceRefreshByDept[0].departmentName}`}</h2>
            </div>
            <div className='col-sm-6'>
              <Button variant='primary' className='float-right' onClick={() => window.history.back()}>
                Back
              </Button>
            </div>
          </div>
          <ReactTable
            resizable
            columns={perDeptColumns}
            filterable
            showPagination={false}
            pageSize={data.queryDeviceRefreshByDept.length}
            className='-striped -highlight mb-5'
            data={data.queryDeviceRefreshByDept}
          />
        </div>
      </React.Fragment>
    );
  }
};
